<template>
    <section class="contract-flow-select-signers">
        <div class="select-signers">
            <span class="title-select-signers">2 - Selecionar Assinantes</span>
            <span class="subtitle-select-signers">Selecione os indivíduos e defina seus respectivos papeis no fluxo de assinatura do contrato.</span>
        </div>

        <div class="envelope-status scroll-color">
            <div class="marker-paper-signers">
                <section class="content-marker-paper-signers">
                    <div class="signers">
                        <span>Assinantes</span>
                    </div>

                    <div class="maker-paper">
                        <span class="paper">Papel</span>

                        <span class="maker">Marcador - Nome</span>

                        <span class="maker">Marcador - Assinatura/Aprovador</span>

                        <span class="all-pages">Assinatura obrigatória</span>
                    </div>
                </section>

                <section
                    v-for="(signer, index) in signers"
                    :key="index"
                    :class="{ 'select-last-child': (index + 1) === signers.length }"
                >
                    <div class="select-signers-list">
                        <div class="action-checkbox">
                            <ui-checkbox
                                v-model="signer.selected"
                                :checked="signer.selected"
                                :disabled="signer.type === 'customer'"
                            />

                            <div class="text-user">
                                <span class="label">{{ signer.name }}</span>

                                <span class="perfil">{{ signer.label }}</span>
                            </div>
                        </div>

                        <div class="action-select">
                            <div class="action-select-card">
                                <ui-select-v2
                                    v-model="signer.role"
                                    :data="roleOptions"
                                    :error="!!formValidation.errors[signer.group]?.role"
                                    :observation="formValidation.errors[signer.group]?.role"
                                    return-value="value"
                                    background-color="#FFF"
                                    size="md"
                                    @input="roleHandler(signer)"
                                />
                            </div>

                            <div class="action-select-card">
                                <span class="span-card">
                                    {{ signer.keyword?.name || '-' }}
                                </span>
                            </div>

                            <div class="action-select-card">
                                <span class="span-card">
                                    {{ signer.keyword?.sign || signer.keyword?.approve || '-' }}
                                </span>
                            </div>

                            <div class="action-switch">
                                <ui-switch
                                    v-model="signer.optional"
                                    :checked="!signer?.optional"
                                    design="sm mgb-0"
                                    :value-true="false"
                                    :value-false="true"
                                />
                            </div>

                            <div v-if="signer.type == 'nonuser'" class="action-menu-card">
                                <ui-menu-card icon="far fa-ellipsis-v">
                                    <button @click="editSigner(signer)">
                                        Configurações
                                    </button>
                                </ui-menu-card>
                            </div>
                        </div>
                    </div>

                    <div v-if="hasErrors(signer)" class="errors-list">
                        <ul>
                            <li
                                v-for="(error, index) in formValidation.errors[signer.group]"
                                :key="index"
                            >
                                {{ error }}
                            </li>
                        </ul>
                    </div>
                </section>

                <span class="add-new-signers" @click="addSigner">
                    + Adicionar novo assinante
                </span>
            </div>

            <div class="footer-button">
                <ui-button
                    :disabled="!formValidation?.valid"
                    design="mw-200 primary lg"
                    @click="send"
                >
                    Solicitar Assinaturas
                </ui-button>
            </div>
        </div>

        <ui-add-signers-modal />
    </section>
</template>

<script>
	import { uiButton } from '@/components/ui/buttons'
	import { uiSelectV2, uiCheckbox, uiSwitch } from '@/components/ui/form'
    import { uiMenuCard } from '@/components/ui'
    import { uiAddSignersModal } from '@/components/ui-facilita/products'

    import { docuRoles as roles } from '@/assets/js/data'
    import { mapGetters, mapActions } from 'vuex'
    import { $mx_generateSignerKeyword } from '@/mixins/helpers'

	export default {
		name: 'ui-docu-sign-contract-sign-flow-select-signers',

		components: {
			uiButton,
            uiSelectV2,
            uiCheckbox,
            uiMenuCard,
            uiAddSignersModal,
            uiSwitch
		},

        data() {
            return {
                roleOptions: [...roles],
                interval: null
            }
        },

        computed: {
            ...mapGetters('digitalSignatureStore', {
                signers: 'getSigners',
                formValidation: 'getFormValidation'
            })
        },

        mounted() {
            this.loadDealSigners()
        },

        methods: {
            ...mapActions('digitalSignatureStore', [
                'loadDealSigners',
                'saveEnvelope',
                'setSigners'
            ]),
            /**
             * Abre o modal para o cadastro de assinantes externos
             */
			addSigner() {
				this.$root.$emit('modal-open-docu_sign-add-signers')
			},
            /**
             * Abre o modal para a edição de assinantes externos
             */
			editSigner(event) {
				this.$root.$emit('modal-open-docu_sign-add-signers', event)
			},
            /**
             * Solicita o envio dos dados do envelope e caso esteja tudo correto, solicita
             * o fechamento do modal
             */
            send() {
                this.saveEnvelope().then(() => {
                    // Emite o evento para recarregar o component de Documentos e Contratos
                    let event = new CustomEvent('iframe--contracts-reload-page')
				    window.parent.document.dispatchEvent(event)
                    this.$emit('close')
                })
            },
            /**
             * Verifica se existem erros de formulário referentes a determinado assinante
             */
            hasErrors(signer) {
                return Object.keys(this.formValidation.errors[signer.group] || {}).length
            },
            /**
             * Event handler que recebe um assinante e define suas macros/marcadores
             */
            keywordHandler(value, signer) {
                clearInterval(this.interval)
                this.interval = setInterval(() => {
                    clearInterval(this.interval)
                    this.interval = null
                    signer.keyword = $mx_generateSignerKeyword(value, signer.role)
                }, 2000)
                this.setSigners(this.signers)
            },
            /**
             * Event handler que trata o evento de quando a função de um assinante é selecionada
             * para alterar suas macros
             */
            roleHandler(signer) {
                signer.keyword = $mx_generateSignerKeyword(signer.keyword.name, signer.role)
                this.setSigners(this.signers)
            }
        }
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>